import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { Typography, styled } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Fab from "@mui/material/Fab";
import SaveIcon from '@mui/icons-material/Save';

import AddIcon from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import Clear from "@mui/icons-material/Clear";
import { DeleteDialog } from "../components/DeleteDialog";

import { Link, Navigate } from "react-router-dom";

import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

import {
  collection,
  query,
  setDoc,
  doc,
  onSnapshot,
  or,
  where,
} from "firebase/firestore";
import { Context } from "context/Wrapper";
import { useAdvancedDataListener, useFetchCollectionDocs } from "apis/dataSnapshots";
import { db } from "config/config";
import AdvancedTable from "components/AdvancedTable";
import useCustomParams from "components/shared/useCustomParams";
import tableConfig from "config/advancedTableColumnsControl.json";


const searchLimit = tableConfig?.searchMinLength;

let filterSearchedTimeout = null;

export const Profiles = (props) => {
  const context = useContext(Context);
  const { params, updateParams } = useCustomParams();


  const user = context?.state?.userProfile || {},
    { showAllDataFlag } = context?.state || {};


  const groups = useFetchCollectionDocs({
    collectionName: "groups",
    conditions: [true],
  });

  const [userProfiles, setuserProfiles] = useState([]);

  const navigate = useNavigate();

  const [deleteOpen, setDeleteOpen] = useState(false);

  const [itemToDelete, setItemToDelete] = useState({
    itemId: "",
    identifier: "",
  });

  const [filtereduserProfiles, setFiltereduserProfiles] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const [loading, setLoading] = useState(false);


  let { data, count, refetch } = useAdvancedDataListener({
    user,
    // conditions,
    // setLastRef: setLastVisible,
    fetchAll: true,
    collectionName: "profiles",
    // rowsLimit,
    // params,
  });




  useEffect(() => {
    updateParams({
      page: "",
      search: "",
      pageIncreasing: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading) {
      setuserProfiles(data);
    }
  }, [userProfiles, data]);


  useEffect(() => {
    if (
      (searchValue?.length < searchLimit && searchValue?.length !== 0) ||
      !searchValue
    ) {
      if (searchValue?.length === 0) {
        updateParams({ search: "", pageSize: params.get("pageSize") });
      }
      return;
    }
    if (filterSearchedTimeout !== null) clearTimeout(filterSearchedTimeout);

    filterSearchedTimeout = setTimeout(() => {
      updateParams({ search: searchValue, pageSize: params.get("pageSize") });

      const newArr = userProfiles
        .filter(
          (item) => {

            return item.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
              item.subscription?.toString().toLowerCase().includes(searchValue.toLowerCase()) ||
              item.subscriptionType?.toString().toLowerCase().includes(searchValue.toLowerCase())
              || item.expirationDate?.toString().toLowerCase().includes(searchValue.toString().toLowerCase()) || item.groupId?.toString().toLowerCase().includes(searchValue.toString().toLowerCase())
          }

        )
        .map((item) => {
          let newEmail =
            item.email &&
            item.email.replace(
              new RegExp(searchValue, "gi"),
              (match) =>
                `<mark style="background: #2769AA; color: white;">${match}</mark>`
            );

          let newSubscription =
            item.subscription &&
            item.subscription.replace(
              new RegExp(searchValue, "gi"),
              (match) =>
                `<mark style="background: #2769AA; color: white;">${match}</mark>`
            );
          let newSubscriptionType =
            item.subscriptionType &&
            item.subscriptionType.replace(
              new RegExp(searchValue, "gi"),
              (match) =>
                `<mark style="background: #2769AA; color: white;">${match}</mark>`
            );

          let newExpirationDate =
            item.expirationDate &&
            item.expirationDate.toString().replace(
              new RegExp(searchValue, "gi"),
              (match) =>
                `<mark style="background: #2769AA; color: white;">${match}</mark>`
            );

          let newGroupId =
            item.groupId &&
            item.groupId.toString().replace(
              new RegExp(searchValue, "gi"),
              (match) =>
                `<mark style="background: #2769AA; color: white;">${match}</mark>`
            );

          return {
            ...item,
            email: newEmail,
            groupId: newGroupId,
            subscription: newSubscription,
            subscriptionType: newSubscriptionType,
            expirationDate: newExpirationDate,
          };
        });

      setFiltereduserProfiles(newArr);
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userProfiles, searchValue]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const searchCheck = searchValue.length >= searchLimit;
  const [profilesCollection, setprofilesCollection] = useState([]);
  const [rowCount, setRowCount] = useState();


  useEffect(() => {
    if (!loading) {
      if (searchCheck) {
        setprofilesCollection(filtereduserProfiles);
        setRowCount(profilesCollection?.length)
      } else {
        setprofilesCollection(userProfiles);
        setRowCount(count);
      }
    }
  }, [userProfiles, filtereduserProfiles, searchCheck, rowCount])



  const handleDelete = (id, identifier, row) => {
    setItemToDelete({ itemId: id, identifier: row.email });
    setDeleteOpen(true);
  };

  const handle2FA = async (row, checked) => {

    setprofilesCollection(prev =>
      prev.map(profile =>
        profile.id === row.id ? { ...profile, enforceTwoFactor: checked } : profile
      )
    );
    if (checked) {
      localStorage.setItem("emailSent", true);
    }
    const userRef = doc(db, 'profiles', row.id);
    try {
      // Check if the document exists      
      await setDoc(userRef, { enforceTwoFactor: checked }, { merge: true });
      console.log(`User ${row.id} enforceTwoFactor updated to:`, checked);
    } catch (error) {
      console.error('Error updating enforceTwoFactor:', error);
    }
  };

  const confirmDelete = async () => {
    try {
      setLoading(true);
      await db.collection("profiles").doc(itemToDelete.itemId).delete();
      // Delete all related data from other collections
      await deleteUserRelatedData(itemToDelete.itemId);
      let filterdProjetcs = profilesCollection.filter((profile) => profile.id !== itemToDelete.itemId);
      setprofilesCollection(filterdProjetcs);
      setuserProfiles(filterdProjetcs);

      if (searchCheck) {
        setFiltereduserProfiles(filterdProjetcs);
        setuserProfiles(filterdProjetcs);
      }
      setRowCount((prevCount) => prevCount - 1);
      refetch();
      setItemToDelete({ itemId: "", identifier: "" });
      setDeleteOpen(false);
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false);
    }

  };

 
  /////////////////////////////////////*******handle deletion of user profile*************////////////////////////////////////////////////////////////////////////////
  const deleteUserRelatedData = async (userId) => {

    const collectionsToDeleteFromWithoutRelations = ["contacts", "notes", "documentTypes", "todos"];


    const batch = db.batch();


    for (const collectionName of collectionsToDeleteFromWithoutRelations) {
      const snapshot = await db.collection(collectionName).where("userId", "==", userId).get();
      snapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });
    }


    await batch.commit();


    const collectionsToDeleteFromWithRelations = ["buildings", "projects"]

    for (const collectionName of collectionsToDeleteFromWithRelations) {
      const snapshot = await db.collection(collectionName).where("userId", "==", userId).get();


      for (const doc of snapshot.docs) {
        const docId = doc.id;

        if (collectionName === "projects") {

          await deleteProjectAndRelatedData(docId);
        } else if (collectionName === "buildings") {

          await deleteBuildingAndRelatedData(docId);
        }
      }
    }


  };

  const deleteProjectAndRelatedData = async (projectId) => {
    const batch = db.batch();

    const projectRef = db.collection("projects").doc(projectId);
    batch.delete(projectRef);

    const worktypesRef = db.collection("workTypes").where("projectId", "==", projectId);
    const worktypesSnapshot = await worktypesRef.get();
    worktypesSnapshot.forEach((doc) => {
      batch.delete(doc.ref);
    });

    const filingsRef = db.collection("filings").where("projectId", "==", projectId);
    const filingsSnapshot = await filingsRef.get();
    filingsSnapshot.forEach((doc) => {
      batch.delete(doc.ref);
    });

    await batch.commit();
  };

  const deleteBuildingAndRelatedData = async (buildingId) => {
    const batch = db.batch();

    const buildingRef = db.collection("buildings").doc(buildingId);
    batch.delete(buildingRef);

    const filingsRef = db.collection("filings").where("buildingId", "==", buildingId);
    const filingsSnapshot = await filingsRef.get();
    filingsSnapshot.forEach((doc) => {
      batch.delete(doc.ref);
    });

    await batch.commit();
  };


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////







  if (
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID &&
    user.uid !== process.env.REACT_APP_PROD_FIREBASE_ADMIN_ID &&
    user.uid !== process.env.REACT_APP_PROD_FIREBASE_ADMIN_ID_ALT &&
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID_ALT &&
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID_ALT2 &&
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID_ALT3 &&
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID_ALT4 &&
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID_ALT5 &&
    user.uid !== process.env.REACT_APP_DEV_FIREBASE_ADMIN_ID_ALT6 &&
    user.uid !== process.env.REACT_APP_PROD_FIREBASE_ADMIN_ID_ALT5 &&
    user.uid !== process.env.REACT_APP_PROD_FIREBASE_ADMIN_ID_ALT6
  ) {
    return "You are not authorized to view this page.";
  }


  return (
    <>
      <Fade in={true}>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={8} style={{ position: "sticky" }}>
              <Typography align="left" variant="h4">
                User Profiles
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <Paper
                component="form"
                onSubmit={(e) => e.preventDefault()}
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginLeft: "auto",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  value={searchValue}
                  inputProps={{ "aria-label": "search" }}
                  onInput={handleSearch}
                />
                {searchValue.length > 0 ? (
                  <IconButton
                    sx={{ p: "10px" }}
                    aria-label="search"
                    onClick={() => {
                      setSearchValue("");
                      updateParams({ search: "" });
                      setFiltereduserProfiles([]);
                    }}
                  >
                    <Clear />
                  </IconButton>
                ) : (
                  <IconButton sx={{ p: "10px" }} aria-label="clear">
                    <SearchIcon />
                  </IconButton>
                )}
              </Paper>
            </Grid>
          </Grid>

          
          <AdvancedTable
            data={profilesCollection}
            collectionName="profiles"
            columnsRaw={[
              // {
              // field: "id",
              // headerName: "ID",
              // },
              {
                field: "email",
                headerName: "Email",
                renderCell: ({ row }) => (
                  <div dangerouslySetInnerHTML={{ __html: row.email }}></div>
                ),
              },
              {


                field: "groupId",
                headerName: "Group",
                renderCell: ({ row }) => (
                  <div dangerouslySetInnerHTML={{
                    __html: groups?.find((g) => g?.id === row.groupId)
                      ?.groupName || row.groupId
                  }}></div>
                ),
              },
              {
                field: "subscription",
                headerName: "Subscription",
                renderCell: ({ row }) => (
                  <div
                    dangerouslySetInnerHTML={{ __html: row.subscription }}
                  ></div>
                ),
              },
              {
                field: "subscriptionType",
                headerName: "Subscription Type",
                renderCell: ({ row }) => (
                  <div dangerouslySetInnerHTML={{ __html: row.subscriptionType }}></div>
                ),
              },
              {
                field: "expirationDate",
                headerName: "Expiration Date",
                renderCell: ({ row }) => (
                  <div
                    dangerouslySetInnerHTML={{ __html: row.expirationDate }}
                  ></div>
                ),
              },
            ]}
            rowCount={rowCount}
            handleDelete={handleDelete}
            handle2FA={handle2FA}
          />

        </div>
      </Fade>
      <DeleteDialog
        open={deleteOpen}
        confirmDelete={confirmDelete}
        setDialogOpen={setDeleteOpen}
        identifier={itemToDelete.identifier}
        loading={loading}
      />

    </>
  );
};
